import * as _ from 'lodash-es';

export let ADD_TO_CART;
export let CAR_CHECKOUT_LINK;
export let CAR_TOTAL;
export let COMPARE_BUTTON;
export let COMPARE_LINK;
export let CANCEL_BUTTON;
export let COMPARE_PRODUCT_HEADING;
export let COMPARE_PRODUCTS_HEADING;
export let ITEM_ADDED_TO_YOUR_CART;
export let ITEMS_ADDED_TO_YOUR_CART;
export let ITEMS_IN_THE_CART;
export let ITEM_IN_THE_CART;
export let QTY_LABEL;
export let SELECT_PRODUCT_TO_COMPARE;
export let SELECT_ITEMS_TO_HEADING;
export let VIEW_DESCRIPTION;
export let HIDE_DESCRIPTION;
export let VIEW_COMPARISON;
export let VIEW_SYSTEM_RQMNTS;
export let VIEW_LANGUAGES_SUPPORTED;
export let CONTACT_US;
export let LICENSING_LABEL;
export let CART_URL;
export let REFRESH_ERR_MSG;
export let REFRESH_ERR_MSG_TITLE;
export let MORE_INFO;
// VAT labels
export let VAT_INCLUDED;
export let VAT_SHOWING;
export let VAT_VIEW;
export let VAT_EXCLUDED;
export let VAT_BUSS_PRICE;
export let VAT_CONS_PRICE;

export default class LocalContext {
	static setLabels(labels) {
		let _labels = labels.viewDescription ? labels : this.normalizeIfFullObject(labels);

		ADD_TO_CART = _labels.addToCart;
		CAR_CHECKOUT_LINK = _labels.carCheckoutLink;
		CAR_TOTAL = _labels.carTotal;
		COMPARE_LINK = _labels.compareLink;
		ITEM_ADDED_TO_YOUR_CART = _labels.itemAddedToYourCar;
		ITEMS_ADDED_TO_YOUR_CART = _labels.itemsAddedToYourCar;
		ITEMS_IN_THE_CART = _labels.itemsInTheCart;
		ITEM_IN_THE_CART = _labels.itemInTheCart || 'Item in the cart';
		QTY_LABEL = _labels.qtyLabel;
		VIEW_DESCRIPTION = _labels.viewDescription;
		HIDE_DESCRIPTION = _labels.hideDescription || 'Hide description';
		VIEW_COMPARISON = _labels.viewComparison || 'View comparison';
		VIEW_SYSTEM_RQMNTS = _labels.viewSystemRqmnts || 'View system requirements';
		VIEW_LANGUAGES_SUPPORTED = _labels.viewLanguagesSupported || 'View supported languages';
		CONTACT_US = _labels.contactUs || 'Contact us';
		LICENSING_LABEL = _labels.licensingInfoLabel || 'Licensing Information';
		CART_URL = _labels.cartURL;
		REFRESH_ERR_MSG = _labels.refreshErrorMsg;
		REFRESH_ERR_MSG_TITLE = _labels.refreshErrorMsgTitle;
		MORE_INFO = {
			topLabel: _labels.moreInfoHeadingTop,
			topText: _labels.moreInfoMsgTop,
			bottomLabel: _labels.moreInfoHeadingBottom,
			bottomText: _labels.moreInfoMsgBottom,
		};
		VAT_INCLUDED = _labels.vatIncludedLabel;
		VAT_SHOWING = _labels.vatShowingTxt;
		VAT_VIEW = _labels.vatViewTxt;
		VAT_EXCLUDED = _labels.vatExcludedLabel;
		VAT_BUSS_PRICE = _labels.businessPriceLabel;
		VAT_CONS_PRICE = _labels.consumerPriceLabel;
	}

	static setTableLabels(labels) {
		let _labels = labels.viewDescription ? labels : this.normalizeIfFullObject(labels);
		COMPARE_BUTTON = _labels.compareBtn;
		COMPARE_PRODUCT_HEADING = _labels.compareProductHeading;
		COMPARE_PRODUCTS_HEADING = _labels.compareProductsHeading;
		CANCEL_BUTTON = _labels.cancelButton;
		SELECT_PRODUCT_TO_COMPARE = _labels.selectProdToCompare;
		SELECT_ITEMS_TO_HEADING = _labels.selectItemsToHeading;
	}

	static normalizeIfFullObject(labels) {
		let _labelsWhenTabs = {};
		if (labels[':items']) {
			// component wrapped on tabs and container

			let labelArr = _.values(labels);

			// find comp label
			labelArr.forEach((label) => {
				if (_.isPlainObject(label)) {
					_.forIn(label, (value, key) => {
						if (value.viewDescription) {
							_labelsWhenTabs = value;
							return;
						}
					});
				}
			});
		}
		_labelsWhenTabs = _.isEmpty(_labelsWhenTabs) ? labels : _labelsWhenTabs;
		_labelsWhenTabs.cartURL = labels.cartURL; // add the cart url from AEM config / not from dialog
		return _labelsWhenTabs;
	}
}
